// eslint-disable-next-line import/prefer-default-export
export enum LangCode {
  Czech = "cs",
  English = "en",
}
